module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "price-form"
  }, [_c('top', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con"
  }, [_c('ul', {
    staticClass: "tw"
  }, [(_vm.wechatShow == 1) ? _c('li', {
    staticClass: "p-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.people))]), _vm._v(" "), _c('span', {
    staticClass: "static"
  }, [_vm._v(_vm._s(_vm.wechat))])]) : _vm._e(), _vm._v(" "), (_vm.qqShow == 1) ? _c('li', {
    staticClass: "p-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.people))]), _vm._v(" "), _c('span', {
    staticClass: "static"
  }, [_vm._v(_vm._s(_vm.qq))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "p-text"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.account),
      expression: "form.account"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "id": "",
      "placeholder": "请填写英文、数字"
    },
    domProps: {
      "value": (_vm.form.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "account", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.sale_extend) ? [_c('li', {
    staticClass: "p-text"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.vip_level),
      expression: "form.vip_level"
    }],
    attrs: {
      "type": "number",
      "maxlength": "10",
      "name": "",
      "id": "",
      "placeholder": "请填写VIP等级"
    },
    domProps: {
      "value": (_vm.form.vip_level)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "vip_level", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "p-text"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.e_level),
      expression: "form.e_level"
    }],
    attrs: {
      "type": "number",
      "maxlength": "10",
      "name": "",
      "id": "",
      "placeholder": "请填写电子升级模式等级"
    },
    domProps: {
      "value": (_vm.form.e_level)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "e_level", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "p-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("真人等级")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.r_level),
      expression: "form.r_level"
    }],
    attrs: {
      "type": "number",
      "maxlength": "10",
      "name": "",
      "id": "",
      "placeholder": "请填写真人升级模式等级"
    },
    domProps: {
      "value": (_vm.form.r_level)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "r_level", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.config_info.finance_salary_status === '1') ? _c('li', {
    staticClass: "p-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("电子晋级礼金")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.e_up_reward),
      expression: "form.e_up_reward"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "id": "",
      "placeholder": "请填写电子晋级礼金"
    },
    domProps: {
      "value": (_vm.form.e_up_reward)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "e_up_reward", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.config_info.week_salary_status === '1') ? _c('li', {
    staticClass: "p-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("电子周俸禄")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.e_week_reward),
      expression: "form.e_week_reward"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "id": "",
      "placeholder": "请填写电子周俸禄"
    },
    domProps: {
      "value": (_vm.form.e_week_reward)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "e_week_reward", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.config_info.month_salary_status === '1') ? _c('li', {
    staticClass: "p-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("电子月俸禄")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.e_month_reward),
      expression: "form.e_month_reward"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "id": "",
      "placeholder": "请填写电子月俸禄"
    },
    domProps: {
      "value": (_vm.form.e_month_reward)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "e_month_reward", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.config_info.finance_salary_status === '1') ? _c('li', {
    staticClass: "p-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("真人晋级礼金")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.r_up_reward),
      expression: "form.r_up_reward"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "id": "",
      "placeholder": "请填写真人晋级礼金"
    },
    domProps: {
      "value": (_vm.form.r_up_reward)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "r_up_reward", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.config_info.month_salary_status === '1') ? _c('li', {
    staticClass: "p-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("真人月俸禄")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.r_month_reward),
      expression: "form.r_month_reward"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "id": "",
      "placeholder": "请填写真人月俸禄"
    },
    domProps: {
      "value": (_vm.form.r_month_reward)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "r_month_reward", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "p-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("电子棋牌累计有效投注")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.e_bet_amount),
      expression: "form.e_bet_amount"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "id": "",
      "placeholder": "请填写电子棋牌累计有效投注"
    },
    domProps: {
      "value": (_vm.form.e_bet_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "e_bet_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "p-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("真人累计有效投注")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.r_bet_amount),
      expression: "form.r_bet_amount"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "id": "",
      "placeholder": "请填写真人累计有效投注"
    },
    domProps: {
      "value": (_vm.form.r_bet_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "r_bet_amount", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (!_vm.sale_extend) ? [_c('li', {
    staticClass: "p-text"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.e_level),
      expression: "form.e_level"
    }],
    attrs: {
      "type": "number",
      "maxlength": "10",
      "name": "",
      "id": "",
      "placeholder": "请输入您的等级"
    },
    domProps: {
      "value": (_vm.form.e_level)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "e_level", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.config_info.finance_salary_status === '1') ? _c('li', {
    staticClass: "p-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("等级礼金")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.e_up_reward),
      expression: "form.e_up_reward"
    }],
    attrs: {
      "type": "number",
      "maxlength": "10",
      "name": "",
      "id": "",
      "placeholder": "请填写等级礼金，没填默认0"
    },
    domProps: {
      "value": (_vm.form.e_up_reward)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "e_up_reward", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.config_info.week_salary_status === '1') ? _c('li', {
    staticClass: "p-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("周俸禄")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.e_week_reward),
      expression: "form.e_week_reward"
    }],
    attrs: {
      "type": "number",
      "maxlength": "10",
      "name": "",
      "id": "",
      "placeholder": "请填写周俸禄，没填默认0"
    },
    domProps: {
      "value": (_vm.form.e_week_reward)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "e_week_reward", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.config_info.month_salary_status === '1') ? _c('li', {
    staticClass: "p-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("月俸禄")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.e_month_reward),
      expression: "form.e_month_reward"
    }],
    attrs: {
      "type": "number",
      "maxlength": "10",
      "name": "",
      "id": "",
      "placeholder": "请填写月俸禄，没填默认0"
    },
    domProps: {
      "value": (_vm.form.e_month_reward)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "e_month_reward", $event.target.value)
      }
    }
  })]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.type == 1) ? _c('li', {
    staticClass: "p-text"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.assess_price),
      expression: "form.assess_price"
    }],
    attrs: {
      "type": "number",
      "name": "",
      "id": "",
      "placeholder": "请输入金额"
    },
    domProps: {
      "value": (_vm.form.assess_price)
    },
    on: {
      "keyup": function($event) {
        _vm.form.assess_price = _vm.form.assess_price.replace(/^(0|-[1-9][0-9]*)$/, '')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "assess_price", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.type === 2) ? _c('li', {
    staticClass: "p-text"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.recover_price),
      expression: "form.recover_price"
    }],
    attrs: {
      "type": "number",
      "name": "",
      "id": "",
      "placeholder": "请输入金额"
    },
    domProps: {
      "value": (_vm.form.recover_price)
    },
    on: {
      "keyup": function($event) {
        _vm.form.recover_price = _vm.form.recover_price.replace(/^(0|-[1-9][0-9]*)$/, '')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "recover_price", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.type === 3) ? _c('li', {
    staticClass: "p-text"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.sale_price),
      expression: "form.sale_price"
    }],
    attrs: {
      "type": "number",
      "name": "",
      "id": "",
      "placeholder": "请输入金额"
    },
    domProps: {
      "value": (_vm.form.sale_price)
    },
    on: {
      "keyup": function($event) {
        _vm.form.sale_price = _vm.form.sale_price.replace(/^(0|-[1-9][0-9]*)$/, '')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "sale_price", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.type === 3) ? _c('li', {
    staticClass: "p-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("其他")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.others),
      expression: "form.others"
    }],
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10",
      "placeholder": "你可以补充说明出售账号信息"
    },
    domProps: {
      "value": (_vm.form.others)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "others", $event.target.value)
      }
    }
  })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 1),
      expression: "type === 1"
    }],
    staticClass: "tip activityDesc",
    domProps: {
      "innerHTML": _vm._s(_vm.isassess_description)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 2),
      expression: "type === 2"
    }],
    staticClass: "tip activityDesc",
    domProps: {
      "innerHTML": _vm._s(_vm.isrecover_description)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 3),
      expression: "type === 3"
    }],
    staticClass: "tip activityDesc",
    domProps: {
      "innerHTML": _vm._s(_vm.issell_description)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "p-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认提交")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('b', [_vm._v("*")]), _vm._v("会员账号")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('b', [_vm._v("*")]), _vm._v("VIP等级")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('b', [_vm._v("*")]), _vm._v("电子等级")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('b', [_vm._v("*")]), _vm._v("等级")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('b', [_vm._v("*")]), _vm._v("您的估值")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('b', [_vm._v("*")]), _vm._v("回收出价")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('b', [_vm._v("*")]), _vm._v("出售标价")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce4ac6c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/priceform/priceForm.vue
// module id = 648
// module chunks = 31